import { AppDeployment, CompatibleProductId } from '@atlassian/mpac-types';
import { MarketplaceAppPaymentModel } from '@atlassian/mpac-types/graphql-gateway-types';
import React from 'react';
import { isAppOnlyCompatibleWithProduct } from '../utils';
import { NonConfluenceOnlyPlugins1AppInstallationSteps, OtherServerOrDatacenterAppInstallationSteps, PaidViaAtlassianAppInstallationSteps } from './stepsByType';
const ServerOrDatacenterInstallationSteps = props => {
  const {
    deploymentType,
    compatibleProducts,
    appName,
    productName,
    paymentModel
  } = props;
  if (deploymentType === AppDeployment.PLUGINS1 && !isAppOnlyCompatibleWithProduct(compatibleProducts, CompatibleProductId.Confluence)) {
    return /*#__PURE__*/React.createElement(NonConfluenceOnlyPlugins1AppInstallationSteps, {
      appName: appName,
      productName: productName
    });
  } else if (paymentModel === MarketplaceAppPaymentModel.PaidViaAtlassian) {
    return /*#__PURE__*/React.createElement(PaidViaAtlassianAppInstallationSteps, {
      appName: appName,
      productName: productName
    });
  } else {
    return /*#__PURE__*/React.createElement(OtherServerOrDatacenterAppInstallationSteps, {
      appName: appName,
      productName: productName
      // TODO: check for source of this field with BE
      ,
      deployable: false
    });
  }
};
export default ServerOrDatacenterInstallationSteps;